exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.search-bar-bg[data-v-fc1ce0c0] {\n  background: white;\n}\n", ""]);

// exports
